import { FC } from 'react'

import { useActiveProductsContext } from '~/context/ActiveProducts'
import { useNavigation } from '~/context/Navigation'

import { Backdrop } from '~/components/Backdrop'
import { Icon } from '~/components/Icon'
import { OnboardingAvatarImage } from '~/components/OnboardingAvatarImage'
import { TextButton } from '~/components/TextButton'

import theme from '~/theme'

import Tracking from '~/utils/tracking'
import { translate } from '~/utils/translate'

import * as Styled from './styles'
import { IOnboardingScreenProps } from './types'

export const OnboardingScreen: FC<IOnboardingScreenProps> = ({ visible, handleClose, handleStartOnboarding }) => {
  const { products: activeProducts } = useActiveProductsContext()
  const haveProductsWithSize = Boolean(activeProducts.filter(p => p.has_size).length)

  const testID = 'onboarding-screen'
  const { navigate } = useNavigation()

  const handleCloseFn = () => {
    Tracking.logEvent('TOOLTIP', { origin: Tracking.getLastEventData()?.origin ?? '', action: 'close', widget: true })

    handleClose()
  }

  const startOnboardingHandleClick = () => {
    Tracking.logEvent('TOOLTIP_MENU', { origin: Tracking.getLastEventData()?.origin ?? '', widget: true })

    handleStartOnboarding()
    handleClose()
  }

  const sizingChartHandleButton = () => {
    handleClose()

    navigate('SizingSuggestionScreen')
  }

  return (
    <Backdrop
      visible={visible}
      testID={testID}
      handleClose={handleCloseFn}
      withBackground={true}
      containerStyle={{ backgroundColor: theme.colors.neutral.black200, paddingBottom: '0px' }}
      preventOverflow={false}
      data-testid={`${testID}-backdrop`}
      layerIndex={5}
    >
      <Styled.Container data-testid={`${testID}-content`}>
        <OnboardingAvatarImage />
        <Styled.ContentContainer>
          <Styled.DescriptionText data-testid={`${testID}-description`} align="center">
            {translate('ONBOARDING_SCREEN_DESCRIPTION')}
          </Styled.DescriptionText>

          <Styled.ButtonsContainer>
            <TextButton testID={`${testID}-primary-button`} onClick={startOnboardingHandleClick}>
              {translate('ONBOARDING_SCREEN_BUTTON_START')}
            </TextButton>
            {haveProductsWithSize && (
              <TextButton
                testID={`${testID}-secondary-button`}
                onClick={sizingChartHandleButton}
                background={theme.colors.neutral.black100}
                textColor={theme.colors.primary}
              >
                {translate('ONBOARDING_SCREEN_BUTTON_SIZING_TABLE')}
              </TextButton>
            )}
          </Styled.ButtonsContainer>

          <Styled.TermsContainer>
            <Icon name="locked" size={'16px'} color={theme.colors.neutral.black600} />
            <Styled.Text
              data-testid={`${testID}-terms`}
              align="center"
              dangerouslySetInnerHTML={{
                __html: translate('ONBOARDING_SCREEN_TERMS'),
              }}
            />
          </Styled.TermsContainer>
        </Styled.ContentContainer>
      </Styled.Container>
    </Backdrop>
  )
}
